import React, { FC } from 'react';
import type { PaymentOrchestrationHeroProps } from '@/types';
import { Image } from '../image';
import { TextCols } from '../text-cols';

export const PaymentOrchestrationHero: FC<PaymentOrchestrationHeroProps> = ({
  label,
  title,
  description,
  cover,
}) => {
  return (
    <section className="paymentOrchestrationHero">
      <div className="wrapper">
        <TextCols
          headingLevel="h1"
          size="lg"
          label={label}
          content={{
            title,
            textCol1: description.textCol1,
            textCol2: description.textCol2,
          }}
        />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            loading="eager"
            fetchPriority="high"
            className="paymentOrchestrationHero--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
